import { useState, useCallback } from "react";
import { defaultViewSettings, VIEW_SETTINGS_KEY } from "../types/viewSettings";
const saveViewSettings = (settings) => {
    try {
        localStorage.setItem(VIEW_SETTINGS_KEY, JSON.stringify(settings));
    }
    catch (error) {
        console.error("Failed to save view settings:", error);
    }
};
const loadViewSettings = () => {
    try {
        const saved = localStorage.getItem(VIEW_SETTINGS_KEY);
        if (saved) {
            const parsed = JSON.parse(saved);
            const merged = { ...defaultViewSettings, ...parsed };
            return merged;
        }
    }
    catch (error) {
        console.error("Failed to load view settings:", error);
    }
    return defaultViewSettings;
};
const resetViewSettings = () => {
    try {
        localStorage.removeItem(VIEW_SETTINGS_KEY);
    }
    catch (error) {
        console.error("Failed to reset view settings:", error);
    }
    return defaultViewSettings;
};
export const useViewSettings = () => {
    const [viewSettings, setViewSettings] = useState(() => {
        return loadViewSettings();
    });
    const [isLoaded, setIsLoaded] = useState(true);
    const updateViewSettings = useCallback((newSettings) => {
        setViewSettings(newSettings);
        saveViewSettings(newSettings);
    }, []);
    const updatePartialViewSettings = useCallback((partialSettings) => {
        setViewSettings((prev) => {
            const newSettings = { ...prev, ...partialSettings };
            saveViewSettings(newSettings);
            return newSettings;
        });
    }, []);
    const resetToDefaults = useCallback(() => {
        const defaultSettings = resetViewSettings();
        setViewSettings(defaultSettings);
    }, []);
    return {
        viewSettings,
        updateViewSettings,
        updatePartialViewSettings,
        resetToDefaults,
        isLoaded,
    };
};
//# sourceMappingURL=useViewSettings.js.map